import http from '@/api/client'
import type { ApiResponse } from '@/types/api'
import type { AuthTokens, CurrentUser } from '@/types/auth'

export interface SmsSendPayload {
  phone: string
}

export interface SmsSendResult {
  expireSeconds: number
}

export async function sendSmsCode(payload: SmsSendPayload): Promise<ApiResponse<SmsSendResult>> {
  const { data } = await http.post<ApiResponse<SmsSendResult>>('/app/auth/sms/send', payload)
  return data
}

export async function loginBySms(phone: string, code: string): Promise<ApiResponse<AuthTokens>> {
  const { data } = await http.post<ApiResponse<AuthTokens>>('/app/auth/sms/login', { phone, code })
  return data
}

export async function getCurrentUser(): Promise<ApiResponse<CurrentUser>> {
  const { data } = await http.get<ApiResponse<CurrentUser>>('/app/auth/me')
  return data
}

export async function logout(): Promise<void> {
  await http.post('/app/auth/logout')
}
